import { createContext, Dispatch, MutableRefObject, SetStateAction, useContext } from "react"

/**
 * Carries the "share Outlook attendees" opt-in choice up to the Outlook page, so it can be returned to the
 * add-in (per-order) on order save / frame close. The `share` state lives here (not in the toggle) so it
 * survives the toggle's remounts (e.g. booking Step 1 ↔ Step 2). `shareRef` mirrors it for reads at
 * message-send time. `isEdit` + `initialShare` let the toggle start on and reconcile in edit mode.
 * `isOutlookWebFlow` + `outlookAttendeeCount` let the toggle decide whether to render/subscribe WITHOUT
 * reading the create-order form config (which throws when the shared booking dialog is opened outside the
 * create-order flow, e.g. from RoomFinder). Absent (null) outside the Outlook flow.
 */
export type OutlookAttendeesOptInValue = Readonly<{
    shareRef: MutableRefObject<boolean>
    share: boolean
    setShare: Dispatch<SetStateAction<boolean>>
    isEdit: boolean
    initialShare: boolean
    isOutlookWebFlow: boolean
    outlookAttendeeCount: number
}>

const OutlookAttendeesOptInContext = createContext<OutlookAttendeesOptInValue | null>(null)

export const OutlookAttendeesOptInProvider = OutlookAttendeesOptInContext.Provider

export function useOutlookAttendeesOptIn(): OutlookAttendeesOptInValue | null {
    return useContext(OutlookAttendeesOptInContext)
}
